import React, { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';

import { EnvironmentProvider } from '@sbv-clients/data-access-api';
import { AuthProvider } from '@sbv-clients/shared-feature-auth';
import {
  AppQueryClientProvider,
  MuiXLicense,
  PreferenceProvider,
  ThemeProvider,
} from '@sbv-clients/ui-shared';

import { environment } from '../environments/environment';
import Routes from '../routes';

const ConfigurationInjector = ({ children }: { children: React.ReactNode }) => {
  return (
    <EnvironmentProvider
      apiBaseUrl={environment.apiBaseUrl}
      reportsApiUrl={environment.reportsApiUrl}
      chatPublicKey={environment.chatPublicKey}
      environment={environment.environment}
      client="portal"
      enablePBJ={environment.enablePBJ}
    >
      <PreferenceProvider>{children}</PreferenceProvider>
    </EnvironmentProvider>
  );
};

const chunkErrorHandler = (error: unknown) => {
  if (error instanceof Error && error.name === 'ChunkLoadError') {
    window.location.reload();
  } else {
    console.error(error);
  }
};

const App = () => {
  return (
    <ErrorBoundary FallbackComponent={() => null} onError={chunkErrorHandler}>
      <Suspense fallback={<div>Loading...</div>}>
        <ConfigurationInjector>
          <AppQueryClientProvider>
            <ThemeProvider>
              <AuthProvider shouldRefreshTokenOnMount type="portal">
                <Routes />
                <MuiXLicense />
              </AuthProvider>
            </ThemeProvider>
          </AppQueryClientProvider>
        </ConfigurationInjector>
      </Suspense>
    </ErrorBoundary>
  );
};

export default App;
